<template>
    <div class="form-group col-md-6">
        <label for="inputs_phone" class="mb-0"> {{ $t('phone') }} </label>
        <app-input 
            id="inputs_phone" 
            class="form-control" 
            type="tel-input" 
            v-model="selected"
            :placeholder="$t('text_type_input')" 
        />
    </div>
</template>

<script>
    export default {
        name: 'phoneAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
